import { render, staticRenderFns } from "./UqBarBanner.vue?vue&type=template&id=b8c3e0c8&scoped=true&"
import script from "./UqBarBanner.vue?vue&type=script&lang=js&"
export * from "./UqBarBanner.vue?vue&type=script&lang=js&"
import style0 from "./UqBarBanner.vue?vue&type=style&index=0&id=b8c3e0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c3e0c8",
  null
  
)

export default component.exports